import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableHostedPrivacyPolicy = Loadable({
  loader: function loader() {
    return import('../HostedPrivacyPolicy.jsx');
  },
  loading: ComponentLoading
});
export default LoadableHostedPrivacyPolicy;